<template>
  <div>
    <div class="container pb-5">
      <div v-if="!isContentLoaded">
        <div class="placeholder">
          <div class="post-cover"></div>

          <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
              <div class="page-title mt-4 mt-lg-5 mb-3"></div>
            </div>
            <div class="col-12 col-lg-10">
              <div class="row">
                <div class="col">
                  <div class="paragraph" style="width: 35%;"></div>
                  <div class="paragraph" style="width: 45%;"></div>
                </div>
                <div class="col d-flex justify-content-end align-items-center">
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center justify-content-lg-end mt-5">
            <div class="col-12 col-md-10 col-lg-8">
              <div class="paragraph mb-3" style="width: 100%;"></div>
              <div class="paragraph mb-3" style="width: 100%;"></div>
              <div class="paragraph" style="width: 80%;"></div>
            </div>
            <div class="col-12 col-md-3"></div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="post-cover mb-3" v-if="content.acf.cover_image" v-lazy-container="{ selector: 'img' }">
          <img :data-src="content.acf.cover_image.url" :data-srcset="`${content.acf.cover_image.url} 2x`" :alt="content.acf.cover_image" class="img-fluid w-100">
        </div>

        <div class="mt-4">
          <!-- Title -->
          <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
              <h1 class="page-title mb-3" v-html="content.title.rendered"></h1>
            </div>
            <div class="col d-flex justify-content-end align-items-center">
              <social-sharing :url="content.link"
                :title="content.title.rendered"
                :description="content.excerpt.rendered"
                inline-template
                network-tag="a"
              >
                <ul class="nav social-share">
                  <li>
                    <network network="facebook">
                      <span class="icon facebook">Facebook</span>
                    </network>
                  </li>
                  <li>
                    <network network="twitter">
                      <span class="ml-4 icon twitter">Twitter</span>
                    </network>
                  </li>
                </ul>
              </social-sharing>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              <p class="m-0 text-black-50" v-html="dateFormat(content.date)"></p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="page-content" v-html="content.content.rendered"></div>
            </div>
          </div>

          <hr class="my-5">

          <div v-if="!isRelatedPostsLoaded">
            <div class="col-12 col-md-6 col-lg-4 placeholder" v-for="index in 3" :key="index">
              <div class="blog-article">
                <div class="thumbnail mb-3"></div>
                <div class="paragraph mb-4" style="width: 30%;"></div>
                <div class="paragraph mb-2" style="width: 100%;"></div>
                <div class="paragraph" style="width: 80%;"></div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2 class="title text-center" v-html="`${categoryName} ${$t('message.youmaylike')}`"></h2>
            <div class="row my-3">
              <div class="col-12 col-md-6 col-lg-4" v-for="(item, key) in relatedPosts" :key="key">
                <router-link :to="{ name: 'PeopleDetail', params: { slug: decodeURIComponent(item.slug) } }">
                  <div class="blog-article">
                    <div class="people-thumbnail">
                      <div class="thumbnail-media" v-if="item._embedded" :style="{ backgroundImage: `url(${item._embedded['wp:featuredmedia'][0].media_details.sizes['people-thumbnail'].source_url || ''})` }">
                      </div>
                      <!-- /.thumbnail-media -->
                    </div>
                    <!-- /.thumbnail -->
                    <div class="blog-desc text-center">
                      <div class="description mt-4 mb-1" v-html="item.title.rendered"></div>
                      <div class="category" v-html="`${$t('message.by')} ${item.acf.shop_name}`" v-if="item.acf.shop_name"></div>
                    </div>
                    <!-- /.blog-desc -->
                  </div>
                  <!-- /.blog-article -->
                </router-link>
              </div>
            </div>
            <!-- /.row -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import JQuery from 'jquery'
const Flickity = require('flickity')
export default {
  name: 'PeopleDetail',
  data () {
    return {
      title: process.env.VUE_APP_TITLE,
      api_path: process.env.VUE_APP_API_PATH,
      content: [],
      isContentLoaded: false,
      isRelatedPostsLoaded: false,
      relatedPosts: [],
      categoryName: ''
    }
  },
  mounted () {
    this.getContent()
  },
  methods: {
    getContent () {
      const $vm = this
      const slug = $vm.$route.params.slug
      const lang = $vm.$route.params.lang
      $vm.isContentLoaded = false
      axios.get(`${$vm.api_path}wp-json/wp/v2/people`, {
        params: {
          _embed: true,
          slug: encodeURIComponent(slug),
          lang
        }
      })
        .then(async res => {
          if (res.data.length) {
            $vm.content = res.data[0]
            document.title = `${$vm.content.title.rendered} - ${$vm.title}`
            $vm.isContentLoaded = true
            const $ = JQuery
            setTimeout(() => {
              if ($('.has-carousel')) {
                $('.has-carousel').each(function (i) {
                  var options = JSON.parse($(this).attr('data-flickity'))
                  const carousel = new Flickity($('.has-carousel')[i], options)
                  if (carousel) {}
                })
              }
            }, 100)
            const related = await $vm.getRelatedPosts($vm.content.id, $vm.content['people-category'][0])
            if (related.data) {
              $vm.relatedPosts = related.data
              const category = await $vm.getCategoryName($vm.content['people-category'][0])
              if (category.data) {
                $vm.categoryName = category.data.name
              }
              $vm.isRelatedPostsLoaded = true
            }
          }
        })
    },
    async getCategoryName (catId) {
      const $vm = this
      const lang = $vm.$route.params.lang
      const category = await axios.get(`${this.api_path}wp-json/wp/v2/people-category/${catId}`, {
        params: {
          lang
        }
      })
      return category
    },
    async getRelatedPosts (postId, categories) {
      const lang = this.$route.params.lang
      const related = await axios.get(`${this.api_path}wp-json/wp/v2/people`, {
        params: {
          _embed: true,
          'people-category': categories,
          lang,
          per_page: 3,
          exclude: postId
        }
      })
      return related
    },
    dateFormat (date, format = 'D MMMM YYYY') {
      const lang = this.$route.params.lang
      return dayjs(date).locale(lang).format(format)
    }
  },
  watch: {
    '$route' () {
      this.getContent()
    }
  }
}
</script>
